


interface IMAPPING {
    [Key: string]: Array<string>;
}

const ENTITY_MAPPING: IMAPPING = {
    'BackgroundModeDto':            ['backgroundmodes', 'backgroundmode', 'backgroundmodedto'],
    'BeaconDto':                    ['beacons', 'beacon', 'beacondto'] ,
    'BeaconSensitivityDto':         ['beaconsensitivities', 'beaconsensitivity', 'beaconsensitivitydto'],
    'FloorPlanDto':                 ['floorplans', 'floorplan', 'floorplandto'],
    'FontAlignmentDto':             ['fontalignments', 'fontalignment', 'fontalignmentdto'],
    'FontFamilyDto':                ['fontfamilies', 'fontfamily', 'fontfamilydto'],
    'FontSizeUnitDto':              ['fontsizeunits', 'fontsizeunit', 'fontsizeunitdto'],
    'FontStyleDto':                 ['fontstyles', 'fontstyle', 'fontstyledto'],
    'LanguageDto':                  ['languages', 'language', 'languagedto'],
    'MediumDto':                    ['media', 'medium', 'mediumdto'],
    'MenuItemDto':                  ['menuitems', 'menuitem', 'menuitemdti'],
    'MenuItemTranslationDto':       ['menuitemtranslations', 'menuitemtranslation', 'menuitemtranslationdto'],
    'PinTypeDto':                   ['pintypes', 'pintype', 'pintypedto'],
    'ScreenOrientationDto':         ['screenorientations', 'screenorientation', 'screenorientationdto'],
    'SiteDto':                      ['sites', 'site', 'sitedto'],
    'SiteObjectOnFloorPlanDto':     ['siteobjectonfloorplans', 'siteobjectonfloorplan', 'siteobjectonfloorplandto'],
    'SiteObjectDto':                ['siteobjects', 'siteobject', 'siteobjectdto'],
    'SiteObjectTranslationDto':     ['siteobjecttranslations', 'siteobjecttranslation', 'siteobjecttranslationdto'],
    'SiteObjectTypeDto':            ['siteobjecttypes', 'siteobjecttype', 'siteobjecttypedto'],
    'SiteSupportedLanguageDto':     ['sitesupportedlanguages', 'sitesupportedlanguage', 'sitesupportedlanguagedto'],
    'StyleDto':                     ['styles', 'style', 'styledto'],
    'TourMenuItemDto':              ['tourmenuitems', 'tourmenuitem', 'tourmenuitemdto'],
    'TourRelatedSiteObjectDto':     ['tourrelatedsiteobjects', 'tourrelatedsiteobject', 'tourrelatedsiteobjectdto'],
    'TourDto':                      ['tours', 'tour', 'tourdto'],
    'TourStatusDto':                ['tourstatuses', 'tourstatus', 'tourstatusdto'],
    'TourSubTypeDto':               ['toursubtypes', 'toursubtype', 'toursubtypedto'],
    'TourSupportedLanguageDto':     ['toursupportedlanguages', 'toursupportedlanguage', 'toursupportedlanguagedto'],
    'TourTranslationDto':           ['tourtranslations', 'tourtranslation', 'tourtranslationdto'],
    'TourTypeDto':                  ['tourtypes', 'tourtype', 'tourtypedto'],
}

function entityNameFromPatchPath(path: string) : string|null {
    const pathCompare = path.toLowerCase();

    for ( const entityname of Object.keys(ENTITY_MAPPING) ) {
        const mapped = ENTITY_MAPPING[entityname];
        for ( const mapName of mapped ) {
            if ( mapName === pathCompare ) {
                return entityname;
            }
        }
    }

    return null;
}

function patchPathFromEntityName(entityName: string) : string|null {
    const mapArray = ENTITY_MAPPING[entityName];
    return Array.isArray(mapArray) ? mapArray[0] : null;
}

function tableNameFromInterfaceName(interfaceName: string): string {
    return interfaceName;
}

function interfaceNameFromEntityName(entityName: string): string {
    return 'I' + entityName;
}

function entityNameFromInterfaceName(interfaceName: string): string {
    return interfaceName.substring(1);
}

function tableNameFromEntityName(interfaceName: string): string {
    return tableNameFromInterfaceName(interfaceNameFromEntityName(interfaceName));
}

function entityNameFromTableName(tableName: string): string {
    return entityNameFromInterfaceName(tableName);
}

export default {
    mappings: ENTITY_MAPPING,
    entityNameFromPatchPath,
    patchPathFromEntityName,
    tableNameFromInterfaceName,
    interfaceNameFromEntityName,
    entityNameFromInterfaceName,
    tableNameFromEntityName,
    entityNameFromTableName,
};
